export const API_URL = '../menu.json';
export const TIMEOUT_SEC = 10;
export const MENU_CATS = ["pasta", "antipasti", "classics", "seafood", "meat-food"];
